
const router_modular = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home')
    },
]
export default router_modular